import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { TaxIdentifierModel } from 'src/app/models/customer_master_model/tax-identifier-model';
import { UserTaxIdentifiersModel, User_Tax_Identifiers } from 'src/app/models/customer_master_model/tax-identifiers';
import { CompanyApiService } from 'src/app/services/domain_code/company-api.service';
import { VerifyCustomerService } from '../verify-customer.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'logzy-kyc-verification',
    templateUrl: './kyc-verification.component.html',
    styleUrls: ['./kyc-verification.component.scss']
})
export class KycVerificationComponent implements OnInit {
    companyId: string;
    companyKycDocs: MatTableDataSource<UserTaxIdentifiersModel>;
    UTLength: number; //user_tax_identifier index
    companyKycDocModel: User_Tax_Identifiers;
    taxIdentifierList: TaxIdentifierModel[] = [];
    refreshDocList: boolean = false;
    loading: boolean = true;
    displayColumns = ['document_name', 'id_value', 'document', 'remarks', 'status', 'admin_remarks', 'actions'];
    errorObj: any = [];
    docErrorObj: any;

    companyObj: any;

    constructor(private route: ActivatedRoute,
        private router: Router,
        private verifyCustomerService: VerifyCustomerService,
        private companyService: CompanyApiService,
        private snackBar: MatSnackBar,
    ) { }

    ngOnInit(): void {
        this.route.queryParams.subscribe(params => {
            if ('id' in params) {
                this.companyId = params['id'];
                this.getCompany(params['id']);
            }
        });
    }

    navigateTo(id){
       window.open('master-data/customer-master?id='+id,'_blank');
    }

    getCompany(companyId) {
        this.companyService.getCompanyForKyc(companyId).subscribe({
            next: res => {
                this.companyObj = res;
                this.companyKycDocs = new MatTableDataSource(this.companyObj.tax_identifiers);
                this.UTLength = this.companyObj.tax_identifiers.length;
                this.route.queryParams.subscribe(params => {
                    if ('country' in params) {
                        this.getTaxIdentifierList(params['country'], this.companyObj.tax_identifiers)
                    }
                });
            }
        });
    }

    getTaxIdentifierList(countryId, kycDocList) {
        this.companyService.getTaxIdentifierByCountry(countryId).subscribe({
            next: response => {
                this.taxIdentifierList = [];
                let difference = response.results.filter(item1 => !kycDocList.find(item2 => item2.tax_identifier?.id === item1.id));

                for (let i = 0; i < difference.length; i++) {
                    if (difference[i] != null) {
                        let data = [...this.taxIdentifierList]
                        data.push(difference[i])
                        this.taxIdentifierList = data;
                    }
                }

                this.loading = false;
                this.refreshDocList = false;
            },
            error: error => {
                console.log(error)
                return error;
            }
        });
    }

    kycDocVerification(devName, doc, idx) {
        this.refreshDocList = true
        let payload = {
            status_dev_name: devName,
            admin_remarks: doc.admin_remarks
        }
        this.verifyCustomerService.putKycDocsOfCompany(doc.id, payload).subscribe({
            next: res => {
                this.snackBar.open(`${doc.tax_identifier?.name} status updated!`, 'Close', {
                    verticalPosition: 'top',
                    duration: 2000,
                });
                this.getCompany(this.companyId);
            },
            error: err => {
                this.refreshDocList = false;
                this.errorObj[idx] = { ...err.error }
                console.log(err);
            }
        })
    }

    addDocument(doc, i) {
        if (doc != null) {
            this.hideOtherrows(i);
            if ('tax_identifier' in doc) {
                this.companyKycDocModel = new User_Tax_Identifiers();
                this.companyKycDocModel.savePayloadToModel(doc)
            } else {
                this.companyKycDocModel = new User_Tax_Identifiers();
                this.companyKycDocModel.tax_identifier = doc;
            }
        }
    }

    hideOtherrows(i) {
        if (i != null) {
            for (let index = 0; index < this.UTLength; index++) {
                if (index != i) {
                    document.getElementById('row-id-' + index).style.display = 'none';
                }
            }
            if (this.taxIdentifierList.length > 0) {
                document.getElementById('additionalDoc').style.display = 'none';
            }
        } else {
            for (let index = 0; index < this.UTLength; index++) {
                document.getElementById('row-id-' + index).style.display = 'flex';
            }
            if (this.taxIdentifierList.length > 0) {
                document.getElementById('additionalDoc').style.display = 'flex';
            }
            this.companyKycDocModel = null;
        }
    }

    saveKYC(data) {
        if (data.id == null) {
            let payload = {
                tax_identifier: data.tax_identifier != null ? data.tax_identifier.id : null,
                document: data.document != null ? data.document.id : null,
                id_value: data.id_value ? data.id_value : null,
                admin_remarks: data.admin_remarks ? data.admin_remarks : null,
            }

            this.companyService.postUserTaxIdentifierItem(payload, this.companyId).subscribe({
                next: res => {
                    this.snackBar.open("KYC document added successfully!", 'Close', {
                        verticalPosition: 'top',
                        duration: 2000,
                    });
                    this.getCompany(this.companyId);
                    this.companyKycDocModel = null;
                },
                error: err => {
                    if (err.status > 399 && err.status < 500) {
                        this.docErrorObj = { ...err.error };
                    }
                    if (err.status > 499) {
                        this.snackBar.open("Something went wrong! Please try again later.", 'Close', {
                            verticalPosition: 'top',
                            duration: 2000,
                        });
                    }
                    return err;
                }
            });
        } else {
            let payload = {
                company: this.companyId,
                tax_identifier: data.tax_identifier != null ? data.tax_identifier.id : null,
                document: data.document != null ? data.document.id : null,
                id_value: data.id_value ? data.id_value : null,
                admin_remarks: data.admin_remarks ? data.admin_remarks : null,
            }

            this.companyService.putUserTaxIdentifierItem(payload, data.id).subscribe({
                next: res => {
                    this.snackBar.open("KYC details updated successfully!", 'Close', {
                        verticalPosition: 'top',
                        duration: 2000,
                    });
                    this.getCompany(this.companyId);
                    this.hideOtherrows(null);
                },
                error: err => {
                    if (err.status > 399 && err.status < 500) {
                        this.docErrorObj = { ...err.error };
                    }
                    if (err.status > 499) {
                        this.snackBar.open("Something went wrong! Please try again later.", 'Close', {
                            verticalPosition: 'top',
                            duration: 2000,
                        });
                    }
                    return err;
                }
            });
        }
    }

    closeDetails() {
        this.router.navigateByUrl(`verify-customer-kyc`);
    }
}
